import Instruction from './Instruction';
export default Instruction;